// extracted by mini-css-extract-plugin
export var divider = "_ts-0";
export var systemMessage = "_ts-1";